export default __webpack_public_path__ + "static/media/usuario.402e33f3.png";